import { callApi } from "../callApi"
import { ROLES_TITLE } from "./getPartnerUuidRoles"

export type ROLE_RULE = {
  base_behavior: boolean
  actions: string[]
  subjects: string[]
  conditions: Record<string, unknown>
}

export type LOGGED_USER_ROLE = {
  name?: ROLES_TITLE
  rules?: ROLE_RULE[]
  fleets?: unknown[] | null
}

export const getPartnerUuidRolesMe = async (partnerUuid: string) => {
  return callApi<null, LOGGED_USER_ROLE>({
    method: "GET",
    path: `/partner/${partnerUuid}/roles/me`,
  })
}
